import { useState } from "react";
import { useTranslation } from "react-i18next";
import { type IEnabled2FA } from "#src/services/workspace";
import { ButtonV2 } from "#src/commonV2/Button";
import { ModalV2 } from "#src/commonV2/modal/ModalV2";
import { RadioV2 } from "#src/commonV2/inputs/Radio";
import { EnterpriseRoleEnum } from "#src/config/filter/workspace/enum";

type IEnable2FAModalProps = {
  open: boolean;
  callingAPI: boolean;
  onClose: () => void;
  enabled2fa: (data: IEnabled2FA) => Promise<void>;
};

export const Enable2FAModal = ({
  open,
  callingAPI,
  onClose,
  enabled2fa,
}: IEnable2FAModalProps) => {
  const { t } = useTranslation("workspace", {
    keyPrefix: "security.enable2FAModal",
  });

  // --------------- DATA ---------------

  const [role, setRole] = useState<string>(EnterpriseRoleEnum.ADMIN);

  // --------------- RENDER ---------------
  return (
    <ModalV2 open={open} onChangeOpen={onClose}>
      <span className="text-lg font-semibold text-gray-v2-900">
        {t("title")}
      </span>
      <div className="flex flex-col gap-4 text-md text-gray-v2-600">
        {/* Desc */}
        <p>{t("desc")}</p>
        {/* Desc end */}
        <div className="flex gap-3 items-center">
          <RadioV2
            checked={role === EnterpriseRoleEnum.ADMIN}
            onClick={() => setRole(EnterpriseRoleEnum.ADMIN)}
          />
          <p className="text-md font-medium text-gray-v2-700">
            {t("role.admin")}
          </p>
        </div>
        <div className="flex gap-3 items-center">
          <RadioV2
            checked={role === EnterpriseRoleEnum.ALL}
            onClick={() => setRole(EnterpriseRoleEnum.ALL)}
          />
          <p className="text-md font-medium text-gray-v2-700">
            {t("role.all")}
          </p>
        </div>
      </div>
      {/* Footer */}
      <div className="flex gap-3 justify-end">
        <ButtonV2
          variant="secondary"
          size="lg"
          color="gray"
          disabled={callingAPI}
          onClick={onClose}
        >
          <p>{t("button.cancel")}</p>
        </ButtonV2>

        <ButtonV2
          variant="primary"
          size="lg"
          pending={callingAPI}
          onClick={() =>
            enabled2fa({ enabled_2fa: true, enabled_2fa_roles: role })
          }
        >
          <p>{t("button.save")}</p>
        </ButtonV2>
      </div>
      {/* Footer end */}
    </ModalV2>
  );
};
